import React, { useState, useRef, useEffect } from "react";
import { Form, Input, Button, Space, Table, Menu, Image } from "antd";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import baseRequest from "../../utils/baseRequest";
import VideoPlayer from "../../components/VideoPlayer";
const FeedbackContent = (props) => {
  const { TextArea } = Input;
  const current = props.current;
  //表头
  const columns = [
    {
      title: "用户ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "用户昵称",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "反馈描述",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "辅助材料",
      dataIndex: "credentials",
      key: "credentials",
      width: 500,
      render: (data) => (
        <div
          className={`grid ${
            (data.media?.images[0]?.h <= data.media?.images[0]?.w &&
              data.media?.images.length < 4) ||
            data.media?.images.length === 0
              ? "grid-cols-2"
              : "grid-cols-4"
          } gap-2`}
        >
          {data.images?.map((item, index) => (
            <div className="self-start" key={index}>
              <Image src={item.urls[0]} style={{ marginBottom: 10 }} />
            </div>
          ))}
          {data.videos?.map((item, index) => (
            <div className="self-start" key={index}>
              <VideoPlayer url={item.urls[0]} />
            </div>
          ))}
        </div>
      ),
    },
    {
      title: "提交时间",
      dataIndex: "submitTime",
      key: "submitTime",
    },
    {
      title: "备注",
      dataIndex: "remark",
      key: "remark",
      render: (_, record) => (
        <Form.Item name={record.key} initialValue={record.remark}>
          <TextArea rows={4} />
        </Form.Item>
      ),
    },
    {
      title: "操作",
      dataIndex: "opeartion",
      key: "opeartion",
      render: (_, record) => (
        <div>
          <Space>
            <Space.Compact direction="vertical">
              <Button type="primary" onClick={() => onClickSubmit(record)}>
                {current === "pending" && "跟进"}
                {current === "inProgress" && "归档"}
                {current === "done" && "跟进"}
                {current === "invalid" && "跟进"}
                {current === "iteration" && "归档"}
              </Button>
              {current !== "invalid" && (
                <Button onClick={() => onClickInvalid(record)}>无效</Button>
              )}
              {(current === "pending" || current === "inProgress") && (
                <Button onClick={() => onClickIteration(record)}>
                  设为迭代
                </Button>
              )}
            </Space.Compact>
          </Space>
        </div>
      ),
    },
  ];
  //给表单绑定ref
  const formRef = useRef(null);
  //点击修改状态按钮
  const onClickSubmit = (record) => {
    formRef.current.key = record.key;
    formRef.current.btn = "submit";
    formRef.current.submit();
  };
  //点击无效按钮
  const onClickInvalid = (record) => {
    formRef.current.key = record.key;
    formRef.current.btn = "invalid";
    formRef.current.submit();
  };
  //点击迭代相关按钮
  const onClickIteration = (record) => {
    formRef.current.key = record.key;
    formRef.current.btn = "iteration";
    formRef.current.submit();
  };
  //提交表单
  const handleSubmit = async (value) => {
    //要提交的数据
    let status;
    if (formRef.current.btn === "invalid") {
      status = 3;
    } else if (formRef.current.btn === "iteration") {
      status = 4;
    } else {
      switch (current) {
        case "pending":
          status = 1;
          break;
        case "inProgress":
          status = 2;
          break;
        case "done":
          status = 1;
          break;
        case "invalid":
          status = 1;
          break;
        case "iteration":
          status = 2;
          break;
        default:
          break;
      }
    }
    const submitData = {
      id: formRef.current.key,
      remarks: value[formRef.current.key],
      status: status,
    };
    //提交数据
    try {
      const base = baseRequest();
      const response = await fetch("/op/feedback/update", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...submitData,
          ...base,
        }),
      });
      const updateData = await response.json();
      if (updateData.ret === -1) {
        alert(updateData.msg);
        return;
      }
      //取消数据展示
      setShowData(showData.filter((item) => item.key !== submitData.id));
    } catch (error) {
      console.error(error);
    }
  };

  //获取数据
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [more, setMore] = useState(1);
  const getData = async () => {
    if (!more) return;
    let querryStatus;
    switch (current) {
      case "pending":
        querryStatus = 0;
        break;
      case "inProgress":
        querryStatus = 1;
        break;
      case "done":
        querryStatus = 2;
        break;
      case "invalid":
        querryStatus = 3;
        break;
      case "iteration":
        querryStatus = 4;
        break;
      default:
        break;
    }
    try {
      const base = baseRequest();
      const response = await fetch("/op/feedback/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: querryStatus,
          offset: offset,
          limit: 200,
          ...base,
        }),
      });
      const temData = await response.json();
      if (temData.ret === -1) {
        alert(temData.msg);
        return;
      }
      const userMids = temData.data.list.map((item) => item.mid);
      if (userMids.length === 0) {
        setData([]);
        return;
      }
      const userResponse = await fetch("/op/account/list_others_by_mids", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mids: userMids,
          limit: 200,
          ...base,
        }),
      });
      const userData = await userResponse.json();
      if (userData.ret === -1) {
        alert(userData.msg);
        return;
      }
      //合并未读信息和用户资料数组
      const combinedArray = temData.data.list.map((item1) => {
        const matchingItem = userData.data.list.find(
          (item2) => item2.mid === item1.mid
        );
        return { ...item1, ...matchingItem };
      });
      const structedData = combinedArray.map((item) => {
        return {
          key: item.id,
          id: item.user_id,
          name: item.name,
          description: item.discription,
          credentials: item.credentials,
          submitTime: new Date(item.ct * 1000).toLocaleString(),
          remark: item.remarks,
          status: item.status,
        };
      });
      setData([...data, ...structedData]);
      setOffset(temData.data.offset);
      setMore(temData.data.more);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getData();
  }, [current]);

  //展示的数据
  const [showData, setShowData] = useState(data);
  useEffect(() => {
    setShowData(data);
  }, [data]);
  //搜索名人
  const search = (value) => {
    value.name || value.id
      ? setShowData(
          data.filter(
            (item) =>
              item.name.toLowerCase().includes(value.name.toLowerCase()) &&
              item.id.toString().includes(value.id)
          )
        )
      : setShowData(data);
  };
  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <p>
        {current === "pending" && `待处理${showData.length}条`}
        {current === "inProgress" && `跟进中${showData.length}条`}
        {current === "done" && `已处理${showData.length}条`}
        {current === "invalid" && `无效反馈${showData.length}条`}
        {current === "iteration" && `迭代相关${showData.length}条`}
      </p>
      <Form name="search" onFinish={search} onFinishFailed={onFinishFailed}>
        <Space style={{ marginBottom: 20 }}>
          <Form.Item label="用户ID" name="id" style={{ margin: 0 }}>
            <Input />
          </Form.Item>
          <Form.Item label="用户昵称" name="name" style={{ margin: 0 }}>
            <Input />
          </Form.Item>
          <Button type="primary" htmlType="submit">
            搜索
          </Button>
        </Space>
      </Form>
      <Form
        ref={formRef}
        name="remark"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Table
          columns={columns}
          dataSource={showData}
          pagination={{ pageSize: 20 }}
          scroll={{ y: window.innerHeight - 300 }}
        />
      </Form>
    </div>
  );
};

export default function Feedback() {
  const navigate = useNavigate();
  //当前tab
  const location = useLocation();
  const pathname = location.pathname.split("/")[2] || "pending";
  const [current, setCurrent] = useState(pathname);
  //tab名称
  const items = [
    {
      label: "待处理",
      key: "pending",
    },
    {
      label: "跟进中",
      key: "inProgress",
    },
    {
      label: "已处理",
      key: "done",
    },
    {
      label: "无效反馈",
      key: "invalid",
    },
    {
      label: "迭代相关",
      key: "iteration",
    },
  ];
  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.key);
    window.location.reload();
  };

  return (
    <div>
      <Menu
        onClick={onClick}
        selectedKeys={[current]}
        mode="horizontal"
        items={items}
      />
      <Routes>
        <Route path="/" element={<Navigate to="/feedback/pending" />} />
        <Route
          path="/pending"
          element={<FeedbackContent current="pending" />}
        />
        <Route
          path="/inProgress"
          element={<FeedbackContent current="inProgress" />}
        />
        <Route path="/done" element={<FeedbackContent current="done" />} />
        <Route
          path="/invalid"
          element={<FeedbackContent current="invalid" />}
        />
        <Route
          path="/iteration"
          element={<FeedbackContent current="iteration" />}
        />
      </Routes>
    </div>
  );
}
